!(function () {
    "use strict";

    if (!customElements.get("locations-component")) {
        customElements.define(
            "locations-component",
            class Locations extends HTMLElement {
                constructor() {
                    super();

                    this.flkty = null;
                    this.flktyNav = null;
                    this.resizeEvent = () => this.enableAdaptiveHeight();
                }

                connectedCallback() {
                    this.slider = this.querySelector("[data-slider-gallery]");
                    this.sliderNav = this.querySelector("[data-slider-info]");

                    const slidesCount = this.querySelectorAll("[data-slide-item]").length;
                    this.flkty = window.theme.Flickity.data(this.slider);
                    this.flktyNav = window.theme.Flickity.data(this.sliderNav);

                    if (slidesCount <= 1) {
                        return;
                    }

                    this.flkty = new window.theme.Flickity(this.slider, {
                        fade: true,
                        wrapAround: true,
                        adaptiveHeight: true,
                        prevNextButtons: false,
                        pageDots: false,
                    });

                    // iOS smooth scrolling fix
                    window.theme.flickitySmoothScrolling(this.slider);

                    this.flktyNav = new window.theme.Flickity(this.sliderNav, {
                        fade: true,
                        wrapAround: true,
                        imagesLoaded: true,
                        asNavFor: this.slider,
                        prevNextButtons: true,
                        pageDots: false,
                    });

                    document.addEventListener("theme:resize", this.resizeEvent);

                    // Wait for CSS/fonts to load before calculating heights
                    const performInitialCalculation = () => {
                        if (!this.isConnected) return;
                        this.enableAdaptiveHeight();
                        this.flkty.resize();
                        this.flktyNav.resize();
                    };

                    const scheduleCalculation = () => {
                        requestAnimationFrame(() => {
                            requestAnimationFrame(performInitialCalculation);
                        });
                    };

                    if (document.readyState === "complete") {
                        scheduleCalculation();
                    } else {
                        window.addEventListener("load", scheduleCalculation, { once: true });
                    }

                    // Trigger text change on image move/drag
                    this.flktyNav.on("change", () => {
                        this.flkty.selectCell(this.flktyNav.selectedIndex);

                        if (window.theme.isMobile()) {
                            let { stickyHeaderHeight } = window.theme.readHeights();
                            const headerHeight = stickyHeaderHeight || 0;
                            const scrollTop = Math.round(window.scrollY);
                            const containerOffsetTopPoint = Math.round(
                                this.getBoundingClientRect().top + scrollTop - headerHeight
                            );

                            window.scrollTo({
                                top: containerOffsetTopPoint,
                                left: 0,
                                behavior: "smooth",
                            });
                        }
                    });

                    // Trigger text change on image move/drag
                    this.flkty.on("change", () => {
                        this.flktyNav.selectCell(this.flkty.selectedIndex);
                    });
                }

                enableAdaptiveHeight() {
                    this.flktyNav.options.adaptiveHeight = false;

                    if (window.theme.isMobile()) {
                        this.flktyNav.options.adaptiveHeight = true;
                    }

                    this.flktyNav.resize();
                }

                disconnectedCallback() {
                    document.removeEventListener("theme:resize", this.resizeEvent);
                }
            }
        );
    }
})();